import config from 'config';

const cdnUrl = config.get('public.cdn.baseUrl');

const generateColorSwatchUrl = ({ skuWithoutSize }) => {
  return `${cdnUrl}/media/images/products/${skuWithoutSize}/${skuWithoutSize}-SWATCH.jpg`;
};

export default generateColorSwatchUrl;
